import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  REPORTS_INVOICES_SET_LIST_INVOICE,
  REPORTS_INVOICES_SET_RECEIPT,
  REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT,
  REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL,
  REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL,
  REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_SET_OUTLETS,
  REPORTS_INVOICES_SET_CURRENT_PAGE,
  REPORTS_INVOICES_SET_TOTAL_PAGE
} from 'actions/reports/invoices/constants'

let initialState = {
  invoices: {
    results: [],
    total_items: 0,
    total_pages: 0
  },
  page: 0,
  perPage: 0,
  receiptInvoices: null,
  openRecordPaymentModal: false,
  openCancelInvoiceModal: false,
  openOldCancelInvoiceModal: false,
  recordPayment: {
    id: 0,
    payment_record: {}
  },
  outlets: [],
  currentPage: null,
  totalPage: null
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  switch (action.type) {
    case REPORTS_INVOICES_SET_LIST_INVOICE:
      return {...state, invoices: payload.invoices}
    case REPORTS_INVOICES_SET_RECEIPT:
      return {...state, receiptInvoices: payload.receiptInvoices}
    case REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT:
      return {...state, recordPayment: payload.recordPayment}
    case REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL:
      return {...state, openRecordPaymentModal: true}
    case REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL:
      return {...state, openRecordPaymentModal: false}
    case REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL:
      return {...state, openCancelInvoiceModal: true}
    case REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL:
      return {...state, openCancelInvoiceModal: false}
    case REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL:
      return {...state, openOldCancelInvoiceModal: true}
    case REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL:
      return {...state, openOldCancelInvoiceModal: false}
    case REPORTS_INVOICES_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case REPORTS_INVOICES_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case REPORTS_INVOICES_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    default:
      return {...state}
  }
}

export {reducer}



// WEBPACK FOOTER //
// ./app/reducers/reports/invoices.js